export enum ScriptingLanguage {
    Bash = "Bash",
    CSharp = "CSharp",
    FSharp = "FSharp",
    PowerShell = "PowerShell",
    Python = "Python",
}
